import type { ReactNode } from "react";
import { cx } from "@/lib/cx";

/**
 * Two-column settings section: title and description on the left, controls on the right (max 448px,
 * or `wide` for tables and previews). Sections are separated by a hairline, the first has none.
 * Used by personal Settings and the admin configuration pages.
 */
export function FormSection({
  title,
  description,
  children,
  wide,
  actions,
}: {
  title: string;
  description?: ReactNode;
  children: ReactNode;
  wide?: boolean;
  /** Right-aligned in the title column's header row, e.g. a status badge. */
  actions?: ReactNode;
}) {
  const id = `section-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;
  return (
    <section
      aria-labelledby={id}
      className="grid gap-4 border-t border-line py-7 first:border-t-0 first:pt-2 md:grid-cols-[minmax(0,240px)_minmax(0,1fr)] md:gap-10"
    >
      <div>
        <div className="flex flex-wrap items-center gap-2">
          <h2 id={id} className="text-base font-semibold tracking-snug text-fg">
            {title}
          </h2>
          {actions}
        </div>
        {description ? <p className="mt-1 text-sm text-pretty text-fg-muted">{description}</p> : null}
      </div>
      <div className={cx("flex min-w-0 flex-col gap-5", wide ? "max-w-3xl" : "max-w-md")}>{children}</div>
    </section>
  );
}
